import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './ListTransfer.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Clipboard from '../CommonSet/Clipboard';
import Title from '../CommonSet/Title';
import { ModalTypes } from '../../Constants';
import TextArea from '../CommonSet/TextArea';

//ButtonView, CSS 적용 부분은 각 위치에서 분기.
const exportProperties = {
    type: ModalTypes.LIST_EXPORT,
    titleKey: 'Menus.list_export_title',
    notices: ['Menus.list_export_notice'],
    content: [], // see #setInternalProperties
};

const importProperties = {
    type: ModalTypes.LIST_IMPORT,
    titleKey: 'Menus.list_import_title',
    notices: ['Menus.list_import_notice_1', 'Menus.list_import_notice_2'],
    content: [],
};

class ListTransfer extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.setInternalProperties(props);
        this.contentPlaceholder = this.Utils.getLang('Menus.list_import_placeholder');
        this.state = {
            content: '',
        };
    }

    setInternalProperties(props) {
        if (props.item.type === ModalTypes.LIST_EXPORT) {
            this.properties = exportProperties;
            this.properties.content = this.formatContent(props.item.content);
        } else {
            this.properties = importProperties;
        }
    }

    /**
     * [{data: foo}, {data: bar} ...] 형태의 content를
     * foo
     * bar 식으로 변환한다.
     * @param content
     */
    formatContent(content) {
        if (!content || content.length <= 0) {
            return ' ';
        } else {
            return content
                .map((element) => element.data + '')
                .reduce((prev, next) => {
                    return prev + '\n' + next;
                });
        }
    }

    /**
     * themeSet 에서 LIST_EXPORT 타입의 css를 가져온다.
     * 만약 theme가 없는 경우, 기본 스타일 (./ListTransfer.cssmodule.less) 를 사용한다.
     * workspace 의 경우 BLUE 테마스타일 중 LIST_EXPORT set 을 사용한다.
     * @param theme themeSetName
     */
    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'LIST_EXPORT');
        this.Style = themeStyle || Style;
    }

    /**
     * 해당 컴포넌트를 호출한 측에 onEvent 콜백을 보낸다
     * @param event eventID
     * @param data caller 에게 보낼 데이터
     */
    handleButtonClick = (event, data = undefined) => {
        const { clickButton } = this.props.actions;
        clickButton({
            event: event,
            data: data,
        });
    };

    handleContentChange = (content) => {
        this.setState({ content });
    };

    render() {
        const { content, type } = this.properties;
        const style = this.Style;

        let mainListStyle = style.listExport;
        if (type === ModalTypes.LIST_EXPORT) {
            mainListStyle += ' ' + style.export;
        } else {
            mainListStyle += ' ' + style.import;
        }

        return (
            <div className={mainListStyle}>
                {this.createTitle()}
                <div className={style.contentView}>
                    {this.createNotice()}
                    {this.createContent(content)}
                    {this.createButtonView(content)}
                </div>
            </div>
        );
    }

    createTitle() {
        return (
            <Title
                className={this.Style.title}
                isClose
                onClose={() => this.handleButtonClick('close')}
                children={this.Utils.getLang(this.properties.titleKey)}
            />
        );
    }

    createNotice() {
        const style = this.Style;

        return (
            <div>
                {this.properties.notices.map((element, index) => {
                    return (
                        <div key={index} className={style.noticeView}>
                            <div className={style.icon} />
                            <span className={style.notice}>
                                {this.Utils.getLang(element)}
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    }

    /**
     * Import Modal 의 경우 editable / Export Modal 의 경우 no Editable
     * @param content formatted content string. import 의 경우 빈 값이다.
     */
    createContent(content) {
        return (
            <div>
                <TextArea
                    ref={'content'}
                    className={this.Style.content}
                    placeholder={this.contentPlaceholder}
                    onValueChange={this.handleContentChange}
                    disabled={this.properties.type === ModalTypes.LIST_EXPORT}
                >
                    {content.length === 0 ? '' : content}
                </TextArea>
            </div>
        );
    }

    createButtonView(content) {
        const style = this.Style;
        return this.properties.type === ModalTypes.LIST_EXPORT
            ? this.createExportButtonView(style, content)
            : this.createImportButtonView(style);
    }

    /**
     * 복사하기 : foo \n bar \n ... 식의 String 을 클립보드에 추가한다.
     * 엑셀로 내보내기 : ['foo', 'bar' ...] 의 Array 를 caller 에게 보낸다.
     */
    createExportButtonView(style, content) {
        return (
            <div className={style.buttonView}>
                <Clipboard
                    content={content}
                    onSuccess={() => this.handleButtonClick('copied')}
                >
                    <Button
                        className={style.button}
                        text={this.Utils.getLang('Buttons.duplication')}
                    />
                </Clipboard>
                <Button
                    className={style.button}
                    text={this.Utils.getLang('Buttons.export_to_excel')}
                    onClick={() =>
                        this.handleButtonClick('excel', content.split('\n'))
                    }
                />
            </div>
        );
    }

    createImportButtonView(style) {
        return (
            <div className={style.buttonView}>
                <Button
                    className={style.button}
                    text={this.Utils.getLang('Buttons.list_save')}
                    onClick={() =>
                        this.handleButtonClick(
                            'save',
                            this.getArrayFromContentDiv(),
                        )
                    }
                />
            </div>
        );
    }

    /**
     * Import Modal 에서, editable Div 에 입력한 값을 newLine 을 기준으로 나눈 Array 결과를 반환한다.
     * 중간 라인에서의 빈 값은 실제 빈 값으로 취급한다. 하지만 맨 마지막 값이 빈 값인 경우는 제거한다.
     * @returns {string[]} newLine 에 의해 나눠진 배열
     */
    getArrayFromContentDiv() {
        return trimRight(this.state.content).split(/\n/);
    }
}

ListTransfer.displayName = 'ListTransfer';
ListTransfer.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

/**
 * from blockly library
 */
function trimRight(target) {
    return target.replace(/[\s\xa0]+$/, '');
}

export default connect(
    undefined,
    mapDispatchToProps,
)(ListTransfer);



// WEBPACK FOOTER //
// ./components/ModalSet/ListTransfer.js